class SearchLayout {
  constructor(context, settings, $, debounce) {
    this.phabletSize = 900;
   
    this.element = document.querySelector(".g-search-layout");

    if(this.element === null){
      return;
    }

    this.sortingRadios = this.element.querySelector(".c-sorting-radios");
    this.sortRadiosMobileWrapper = this.element.querySelector(
      ".g-search-layout__radios-mobile"
    );
    this.sortRadiosDesktopWrapper = this.element.querySelector(
      ".g-search-layout__radios-desktop"
    );

    if (window.innerWidth < this.phabletSize) {
      this.moveRadiosMobile();
    }

    window.addEventListener(
      "resize",
      debounce((e) => {
        if (window.innerWidth < this.phabletSize) {
          this.moveRadiosMobile();
          return;
        }
        this.moveRadiosDesktop();
      }, 300)
    );
  }

  moveRadiosMobile() {
    if (
      this.sortRadiosMobileWrapper.querySelector(".c-sorting-radios") === null
    ) {
      this.sortRadiosMobileWrapper.append(this.sortingRadios);
    }
  }

  moveRadiosDesktop() {
    if (
      this.sortRadiosDesktopWrapper.querySelector(".c-sorting-radios") === null
    ) {
      this.sortRadiosDesktopWrapper.append(this.sortingRadios);
    }
  }
}

export default SearchLayout;
